<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'股权融资发布审核',goback:true},{name:'股权融资发布审核详情'}]" :title="'股权融资发布审核详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="账号信息" shadow="never">
                 <el-row>
                  <el-col :span="8" v-if="detailInfo.userVo">
                    <div class="child">
                            <div class="name">账号：</div>
                            <div class="content">{{detailInfo.userVo.userName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="detailInfo.userVo">
                    <div class="child">
                            <div class="name">账号类型：</div>
                            <div class="content">{{detailInfo.userVo.userTypeName}}</div>
                        </div> 
                  </el-col>
                  <el-col :span="8" v-if="detailInfo.userVo">
                    <div class="child">
                            <div class="name">姓名：</div>
                            <div class="content">{{detailInfo.userVo.realName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="detailInfo.userVo">
                    <div class="child">
                            <div class="name">邮箱：</div>
                            <div class="content">{{detailInfo.userVo.email}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="detailInfo.userVo">
                    <div class="child">
                            <div class="name">联系地址：</div>
                            <div class="content">{{detailInfo.userVo.email}}</div>
                        </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="股权融资项目信息" shadow="never">
                 <div class="smallTitle">基本信息</div>
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">项目名称：</div>
                            <div class="content">{{detailInfo.projectName||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">简要描述：</div>
                            <div class="content">{{detailInfo.description||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">封面LOGO：</div>
                            <div class="content"><img class="logos" :src="detailInfo.logo"></div>
                        </div>
                  </el-col>
                 </el-row>
                 <div class="smallTitle">概况</div>
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">行业：</div>
                            <div class="content">{{detailInfo.tradeValue||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">轮次：</div>
                            <div class="content">{{detailInfo.roundsValue||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">出让股权比例：</div>
                            <div class="content">{{detailInfo.equity||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">融资金额：</div>
                            <div class="content">{{detailInfo.financingAmount||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">公司名称：</div>
                            <div class="content">{{detailInfo.companyName||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">项目网址：</div>
                            <div class="content">{{detailInfo.projectUrl||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">公司地址：</div>
                            <div class="content">{{detailInfo.companyAddr||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">成立时间：</div>
                            <div class="content">{{detailInfo.foundTime||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">项目概述：</div>
                            <div class="content super_p" v-html="detailInfo.projectOutline" v-if="detailInfo.projectOutline"></div>
                            <div class="content" v-else>--</div>
                        </div>
                  </el-col>
                </el-row>
                <div class="smallTitle">团队</div>
                <el-row>
                  <el-col :span="24">
                    <div class="tableChild">
                            <el-table
                                :data="detailInfo.teamList"
                                border
                                style="width: 100%">
                                <el-table-column
                                    prop="name"
                                    label="姓名"
                                    
                                    width="100">
                                </el-table-column>
                                <el-table-column
                                    prop="position"
                                    label="职位"
                                    
                                    width="100">
                                </el-table-column>
                                <el-table-column
                                    prop="introduction"
                                    
                                    label="介绍">
                                </el-table-column>
                            </el-table>
                        </div>
                  </el-col>
                </el-row>
                <div class="smallTitle">融资情况</div>
                <el-row>
                  <el-col :span="24">
                    <div class="tableChild">
                            <el-table
                                :data="detailInfo.finList"
                                border
                                style="width: 100%">
                                <el-table-column
                                    prop="equityTime"
                                    label="时间"
                                    
                                    width="150">
                                </el-table-column>
                                <el-table-column
                                    prop="roundsValue"
                                    label="轮次"
                                    
                                    width="100">
                                </el-table-column>
                                <el-table-column
                                    prop="financingAmount"
                                    
                                    width="100"
                                    label="金额">
                                </el-table-column>
                                <el-table-column
                                    prop="mechanism"
                                    
                                    label="机构">
                                </el-table-column>
                            </el-table>
                        </div>
                  </el-col>
                </el-row>
                <div class="smallTitle">财务状况</div>
                <el-row>
                  <el-col :span="24">
                    <div class="tableChild">
                            <el-table
                                :data="detailInfo.financeList"
                                border
                                style="width: 100%">
                                <el-table-column
                                    prop="year"
                                    label="年份"
                                    >
                                </el-table-column>
                                <el-table-column
                                    prop="totalAssets"
                                    label="总资产（元）"
                                    >
                                </el-table-column>
                                <el-table-column
                                    prop="openIncome"
                                    
                                    label="营业收入（元）">
                                </el-table-column>
                                <el-table-column
                                    prop="grossProfit"
                                    
                                    label="毛利润（元）">
                                </el-table-column>
                                <el-table-column
                                    prop="grossProfitRate"
                                    
                                    label="毛利润率">
                                </el-table-column>
                                <el-table-column
                                    prop="netProfit"
                                    
                                    label="净利润（元）">
                                </el-table-column>
                                <el-table-column
                                    prop="netProfitRate"
                                    
                                    label="净利润率">
                                </el-table-column>
                                <el-table-column
                                    prop="totalLiability"
                                    
                                    label="总负债（元）">
                                </el-table-column>
                                <el-table-column
                                    prop="totalLiabilityRate"
                                    
                                    label="负债率">
                                </el-table-column>
                                <el-table-column
                                    prop="ownerEquity"
                                    
                                    label="所有者权益（元）">
                                </el-table-column>
                                <el-table-column
                                    prop="numOrEmploy"
                                    
                                    label="从业人数">
                                </el-table-column>
                            </el-table>
                        </div>
                  </el-col>
                </el-row>
                <div class="smallTitle">BP</div>
                <el-row>
                  <el-col :span="24">
                    <div class="attachment">
                            <ul class="content">
                                <li><span>{{detailInfo.bpName}}</span><i class="el-icon-download" @click="downLoad(detailInfo.bpName,detailInfo.bpPath)"></i></li>
                            </ul>
                        </div>
                  </el-col>
                </el-row>
                <div class="smallTitle">联系方式</div>
                <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">项目联系人：</div>
                            <div class="content">{{detailInfo.projectContact}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{detailInfo.contactPhone}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                  </el-col>
                </el-row>
                <div class="smallTitle">信息采集协议</div>
                <el-row>
                  <el-col :span="24">
                    <div class="child">
                            <div class="name">是否同意《信息采集协议》：</div>
                            <div class="content">是</div>
                        </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="审核结果" shadow="never" v-if="tab==='2'">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">审核结果：</div>
                              <div class="content">{{detailInfo.checkStatusValue}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{detailInfo.createUserName}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detailInfo.updateTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.auditInstructions}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detailInfo:{
                projectName:"",//项目名称：
                description:"",//简要描述：
                logo:"",//封面LOGO：
                tradeValue:"",//行业：
                roundsValue:"",//轮次：
                equity:"",//出让股权比例：
                financingAmount:"",//融资金额：
                companyName:"",//公司名称：
                projectUrl:"",//项目网址：
                companyAddr:"",//公司地址：
                foundTime:"",//成立时间：
                projectOutline:"",//成立时间：
                teamList:[],//团队
                finList:[],//融资情况
                financeList:[],//财务状况
                projectContact:"",//项目联系人：
                contactPhone:"",//联系手机号：
                checkStatusValue:"",//审核结果：
                updateTime:"",//审核时间：
                auditInstructions:"",//说明：
                createUserName:"",//审核账号：
                bpName:'',//文件名称
                userVo:{
                    userName:"",//添加人账号
                    userTypeName:"",//账号类型：
                    realName:"",//姓名：
                    email:"",//邮箱：
                    contactAddress:"",//联系地址：
                    realName:"",//姓名：
                }
            },
			debtStatistics:'',//债权融资统计
			financialLeasingStatistics:'',//融资租赁统计
			equityStatistics:'',//股权融资列表统计
			vouchStatistics:'',//担保服务统计
			policyGuidanceStatistics:'',//政策指引统计
			incubatorStatistics:'',//孵化器统计
			activitySalonStatistics:'',//活动沙龙统计
        }
    },
    methods:{
        downLoad:function(fileName,filePath){
    
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('backstage/equity/financing/reviewLog/details/'+this.id)
          if (code == 200) {            
              this.detailInfo = data;
              this.detailInfo.logo = this.detailInfo.frontPath+this.detailInfo.logo
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>